// widgetable_type'a göre custom widget varsayılan config'leri
const WIDGET_TYPE_DEFAULTS = {
  assignment: {
    cardType: 'assigned',
    icon: 'uil-puzzle-piece',
    routeName: 'user.my-assignment',
    hasRating: true,
    useSlider: false,
  },
};

// Tüm custom widget'lar için ortak fallback
const WIDGET_FALLBACK = {
  cardType: 'assigned',
  icon: 'uil-puzzle-piece',
  routeName: 'user.my-assignment',
  hasRating: false,
  useSlider: false,
};

// Dashboard modül konfigürasyonları mixin
export const dashboardModuleConfigMixin = {
  computed: {
    moduleConfig() {
      return {
        'upcoming_trainings': {
          dataKey: 'assigned_educations',
          cardType: 'assigned',
          icon: 'uil-clock-eight',
          keyPrefix: 'assigned_education_',
          routeName: 'user.my-assignment',
          useSlider: true,
          hasRating: true
        },
        'highlights_trainings': {
          dataKey: 'highlight_educations',
          cardType: 'highlight',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'highlight_education_',
          routeName: 'user.my-assignment',
          hasRating: true
        },
        'most_liked_trainings': {
          dataKey: 'popular_educations',
          cardType: 'popular',
          icon: 'uil-heart',
          keyPrefix: 'popular_education_',
          routeName: 'user.my-assignment',
          hasRating: true
        },
        'expired_trainings': {
          dataKey: 'expired_educations',
          cardType: 'expired',
          icon: 'uil-clock-three',
          keyPrefix: 'expired_education_',
          routeName: 'user.my-assignment',
          hasRating: true
        },
        'new_trainings': {
          dataKey: 'new_trainings',
          cardType: 'new_training',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'new_training_',
          routeName: 'user.my-assignment',
          hasRating: true
        },
        'optional_trainings': {
          dataKey: 'optionalTrainings',
          cardType: 'optional',
          icon: 'uil-clock-three',
          keyPrefix: 'optional_training_',
          routeName: 'user.education-category',
          hasRating: true
        },
        'linkedin-learning': {
          dataKey: 'linkedin_contents',
          cardType: 'provider',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'linkedin_provider_',
          routeName: 'user.providers-trainings',
          routeParams: { provider: 'linkedin' },
          isProvider: true
        },
        'udemy-business': {
          dataKey: 'udemy_contents',
          cardType: 'provider',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'udemy_provider_',
          routeName: 'user.providers-trainings',
          routeParams: { provider: 'udemy' },
          isProvider: true
        },
        'harvard-business': {
          dataKey: 'harvard_contents',
          cardType: 'provider',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'harvard_provider_',
          routeName: 'user.providers-trainings',
          routeParams: { provider: 'harvard' },
          isProvider: true
        },
        'aeroclass': {
          dataKey: 'aeroclass_contents',
          cardType: 'provider',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'aeroclass_provider_',
          routeName: 'user.providers-trainings',
          routeParams: { provider: 'aeroclass' },
          isProvider: true
        },
        'coursera': {
          dataKey: 'coursera_contents',
          cardType: 'provider',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'coursera_provider_',
          routeName: 'user.providers-trainings',
          routeParams: { provider: 'coursera' },
          isProvider: true
        },
        'competency_trainings': {
          dataKey: 'competency_educations',
          cardType: 'assigned',
          icon: 'uil-puzzle-piece',
          keyPrefix: 'competency_training_',
          routeName: 'user.my-assignment',
          hasRating: true
        }
      };
    }
  },
  methods: {
    // Herhangi bir modül item'ı için config döndürür (bilinen tip veya custom widget)
    getItemConfig(item) {
      if (this.moduleConfig[item.type]) {
        return this.moduleConfig[item.type];
      }

      // anasayfada orta menüde yeni menü oluşturdu ise  (ör: "widgetable_type===assignment")
      if (item.widgetable_type) {
        const defaults = WIDGET_TYPE_DEFAULTS[item.widgetable_type] || WIDGET_FALLBACK;
        return {
          ...defaults,
          keyPrefix: 'widget_' + item.id + '_',
        };
      }

      return null;
    },

    // Modül tipine göre ilgili veriyi döndürür
    getModuleData(type, moduleId) {
      const config = this.moduleConfig[type];
      if (config) {
        const data = this[config.dataKey];
        return data?.data || data || [];
      }

      // Custom widget — widget_assignments'tan veri döndür
      if (moduleId && this.widget_assignments) {
        const widgetData = this.widget_assignments[moduleId];
        return widgetData?.data || widgetData || [];
      }

      return [];
    }
  }
};
